
document.addEventListener('DOMContentLoaded',function(){
  var burger=document.querySelector('.burger'), mobile=document.getElementById('MobileMenu');
  if(burger&&mobile){burger.onclick=function(){mobile.classList.add('open')};
    var x=mobile.querySelector('.x'); if(x)x.onclick=function(){mobile.classList.remove('open')};
    mobile.querySelectorAll('a').forEach(function(a){a.onclick=function(){mobile.classList.remove('open')}});}
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting)e.target.classList.add('in')})},{threshold:.12});
  document.querySelectorAll('.rv').forEach(function(el){io.observe(el)});
  document.querySelectorAll('[data-variant-picker]').forEach(function(p){
    var hidden=p.querySelector('input[name="id"]');
    p.querySelectorAll('.size').forEach(function(b){
      b.addEventListener('click',function(){
        if(b.hasAttribute('disabled'))return;
        p.querySelectorAll('.size').forEach(function(s){s.classList.remove('act')});
        b.classList.add('act'); if(hidden)hidden.value=b.getAttribute('data-id');
      });
    });
  });
  var sort=document.getElementById('SortBy'); if(sort)sort.onchange=function(){this.form.submit()};
});
